module.exports = __webpack_public_path__ + "static/bannerNovo2Mobile-8b8a7e2b937b111ec44b7c653cf70e78.jpg";